<template>
  <div>
    <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8"/>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card mb-3">

            <div class="card mb-12" style="min-height: 60vh;">
              <div class="col-md-12">
                <h2 style="margin: 20px 20px 0px;">Admin Logs</h2>
              </div>

              <div class="mb-12"  style="min-height: 60vh; display: flex; flex-direction: row;">
                <div class="col-md-2" style="border-right: 1px solid #e0e0e0">
                  <div class="card-body">

                    <div>
                      <h6 class="heading-small text-muted mb-4">Select a Feature</h6>
                      <a-select showSearch
                                v-model="selectedFeature"
                                placeholder="Select Feature"
                                optionFilterProp="children"
                                style="width: 100%">
                        <a-spin v-if="fetchingFilterData" slot="notFoundContent" size="small" />
                        <a-select-option v-for="feature in features"
                                        :key="feature.value"
                                        :value="feature.value">
                          {{feature.name}}
                        </a-select-option>
                      </a-select>
                    </div>

                    <br/>

                    <br/>

                    <div>
                      <h6 class="heading-small text-muted mb-4">Select Status</h6>
                      <a-select showSearch
                                v-model="selectedActionType"
                                placeholder="Select Action Type"
                                optionFilterProp="children"
                                style="width: 100%">
                        <a-spin v-if="fetchingFilterData" slot="notFoundContent" size="small" />
                        <a-select-option v-for="action in actionTypes"
                                        :key="action.value"
                                        :value="action.value">
                          {{action.name}}
                        </a-select-option>
                      </a-select>
                    </div>

                    <br/>

                    <div>
                      <a-button type="primary"
                                size="large"
                                class="btn btn-primary float-right"
                                @click.prevent="getData">
                        Filter
                      </a-button>
                    </div>

                  </div>
                </div>

                <div class="col-md-10">
                  <div class="card-body">

                    <div class="table-responsive" >
                      <vuetable v-if="tableURL.length > 0"
                                ref="vuetable"
                                :api-url="tableURL"
                                :http-options="httpOptions"
                                :fields="fields"
                                :show-sort-icons="true"
                                :per-page="10"
                                :css="tableCSS.table"
                                pagination-path=""
                                data-path="data"
                                no-data-template="Empty"
                                @vuetable:load-error="onLoadError"
                                @vuetable:pagination-data="onPaginationData"/>
                    </div>

                    <div class="card-footer d-flex justify-content-end bg-transparent">
                      <div class="pagination ui basic segment grid">
                        <vuetable-pagination
                          ref="pagination"
                          @vuetable-pagination:change-page="onChangePage"
                          :css="tableCSS.pagination">
                        </vuetable-pagination>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import HTTPRequest from '../../controllers/httpRequest.js';
import secureStorage from '../../controllers/secureStorage';

export default {
  data() {
    return {
      fetchingFilterData: false,
      features: [],
      actionTypes: [],
      selectedFeature: '',
      selectedActionType: '',
      tableURL: '',
      fields: [
        { name: "feature", title: "Feature" },
        { name: "action_type", title: "Action" },
        { name: "action_by", title: "Action by" },
        { name: "created_at", title: "Date and Time" },
        { name: "updates", title: "Updates" },
      ],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        }
      },
      tableCSS: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
    }
  },
  components: {
    Vuetable,
    VuetablePagination
  },
  computed: {
    ...mapState(['endPoint']),
  },
  mounted: async function () {
    await this.getFilterFields();
    await this.getData();
  },
  methods: {
    getFilterFields: async function () {
      const request = await HTTPRequest.getRequest(`${this.endPoint}admin/filter_fields`);
      const { features, action_types } = request;
      this.features = features;
      this.actionTypes = action_types;
    },

    getData: async function () {
      this.tableURL = '';
      // const request = await HTTPRequest.getRequest(`${this.endPoint}admin/admin_logs`);
      let tableURL = `${this.endPoint}admin/admin_logs?`;
      tableURL += `feature=${this.selectedFeature}`;
      tableURL += `&action_type=${this.selectedActionType}`;

      setTimeout(() => { this.tableURL = tableURL }, 200);
    },

    onLoadError: async function(error) {
      console.log(error)
    },

    onPaginationData: async function(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },

    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
  }
}
</script>

<style scoped>
.header-cont {
  padding: 10px 30px;
  margin-top: 20px;
}
</style>
